import { Component, afterRender, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import { yearByStartEnd } from '../functions/datetime';
import { forkJoin, Subscription } from 'rxjs';

declare var Swiper: any;
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  private routeSub!: Subscription;
  showImportantNotice = true;
  newsupdate: any;
  photos: any;
  PhotosCategoriesPath: any;
  videos: any;
  videoCategoriesPath: any;
  banners: any;
  BannersPath: any;
  currentDate = new Date().toISOString().split('T')[0];
  years: any = [];
  constructor(
    private homeService: HomeService,
    private routes: ActivatedRoute,
  ) {

    afterRender(() => {
      try {
        if (typeof $ !== 'undefined' && typeof Swiper !== 'undefined') {
          if ($(".photoGallery").length) {
            var photoGallery = new Swiper('.photoGallery .swiper-container', {
              loop: false,
              speed: 200,
              //slidesPerView:1,
              slidesPerView: "auto",
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              navigation: {
                nextEl: '.mediaNext',
                prevEl: '.mediaPrev',
              },
              breakpoints: {
                767: {
                  slidesPerView: 1,
                  spaceBetween: 0
                }
              },
            });
            $(".photoGallery .swiper-button-pause").toggle(() => {
              $(this).addClass('play');
              photoGallery.autoplay.stop();
            }, () => {
              $(this).removeClass('play');
              photoGallery.autoplay.start();
              return false;
            });
          }

          if ($(".mediaGallery").length) {
            var mediaGallery = new Swiper('.mediaGallery .swiper-container', {
              loop: false,
              speed: 800,
              //slidesPerView:1,
              slidesPerView: "auto",
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              navigation: {
                nextEl: '.mediaNext',
                prevEl: '.mediaPrev',
              },
              breakpoints: {
                767: {
                  slidesPerView: 1,
                  spaceBetween: 0
                }
              },
            });

            $(".mediaarrow .swiper-button-pause").toggle(() => {
              $(this).addClass('play');
              mediaGallery.autoplay.stop();
            }, () => {
              $(this).removeClass('play');
              mediaGallery.autoplay.start();
              return false;
            });
          }
        }
      } catch(e) {
        console.error('Swiper initialization failed:', e);
      }
    });

  }

  ngOnInit(): void {
    const currentYearStr = new Date().getFullYear().toString();
    const startYear = parseInt(currentYearStr) - 100;
    this.years = yearByStartEnd(startYear, currentYearStr);

    this.routeSub = this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];

      forkJoin({
        news: this.homeService.getnews(model),
        photos: this.homeService.getPhotoCategories(model),
        videos: this.homeService.getVideoCategories(model),
        banners: this.homeService.getbanners(model)
      }).subscribe({
        next: ({ news, photos, videos, banners }) => {
          this.newsupdate = (news?._result || []).map((item: any) => {
            if (item.start_date) {
              const parts = item.start_date.split('-');
              if (parts.length === 3) {
                item.view_start_date = `${parts[2]}/${parts[1]}/${parts[0]}`;
              } else {
                item.view_start_date = item.start_date;
              }
            }
            return item;
          });

          this.photos = photos?._result || [];
          this.PhotosCategoriesPath = photos?.path || '';

          this.videos = videos?._result || [];
          this.videoCategoriesPath = videos?.path || '';

          this.banners = banners?._result || [];
          this.BannersPath = banners?.path || '';
        },
        error: (err) => {
          console.error('Failed to load home page data', err);
        }
      });
    });
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }

  }

  closeImportantNotice(): void {
    this.showImportantNotice = false;
  }
  // ngAfterViewInit(): void {
  //   // this.debounce(this.initializeResTab, 100)();
  //   if ($(".resTab").length) {
  //     $('.resTab').responsiveTabs({
  //       rotate: false,
  //       startCollapsed: 'tab', //accordion
  //       collapsible: 'accordion', //accordion
  //       scrollToAccordion: true,
  //       scrollToAccordionOnLoad: false
  //     });
  //   }
  // }  

}
